/**
 * GA4 product event helper
 *
 * Depends on global product_handle_map / product_handle_valueMap from theme.js.
 *
 * Usage:
 *   pushProductGa4Event(productItem, 'Product link', 'select_item', 0);
 */
(function (window) {
  'use strict';

  function ensureDataLayer() {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  function getProductMetadata(productId) {
    var metadata = {
      item_name: '',
      item_variant: '',
      item_category: '',
      item_category2: 'Standard',
    };

    if (
      typeof product_handle_map !== 'undefined' &&
      product_handle_map.has(productId) &&
      typeof product_handle_valueMap !== 'undefined'
    ) {
      var values = product_handle_valueMap[productId];
      metadata.item_name = values[0];
      metadata.item_variant = values[1];
      metadata.item_category = values[2];
      metadata.item_category2 = values[3];
    }

    return metadata;
  }

  function parsePrice(priceText) {
    return Number(String(priceText || '').replace(/[,円]/g, ''));
  }

  function normalizeCategory3(variantTitle) {
    return String(variantTitle || '').replace('Default Title', 'none');
  }

  function buildGa4Item(productItem, metadata, discount) {
    return {
      item_id: productItem[0],
      item_name: metadata.item_name,
      index: 1,
      item_list_id: productItem[4],
      item_list_name: productItem[4],
      item_category: metadata.item_category,
      item_category2: metadata.item_category2,
      item_category3: normalizeCategory3(productItem[6]),
      item_variant: metadata.item_variant,
      item_brand: 'SHOKZ',
      price: parsePrice(productItem[9]),
      quantity: Number(productItem[10]),
      currency: 'JPY',
      discount: discount,
    };
  }

  function pushProductGa4Event(productItem, buttonName, eventName, discount) {
    if (!productItem || !productItem.length) return;

    var resolvedDiscount = discount || 0;
    var metadata = getProductMetadata(productItem[0]);

    ensureDataLayer();
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: {
        item_list_id: productItem[4],
        item_list_name: productItem[4],
        currency: 'JPY',
        button_name: buttonName,
        items: [buildGa4Item(productItem, metadata, resolvedDiscount)],
      },
    });
  }

  window.pushProductGa4Event = pushProductGa4Event;
})(window);
